import React, { useEffect } from 'react';
import CardsServices from '../CardsServices';
import FooterServices from '../FooterServices';
import Footer from 'src/components/footer';
import { POC_CONTENT } from 'src/shared/utils/string';
import './style.scss';
import { Link } from 'react-router-dom';
import { scrollToTop } from 'src/shared/utils/appConstant';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css'; // Import the desired effect styles
import backgroundImage from '../../../../shared/assets/images/pocbg.jpg';
import { pageRoutes } from 'src/shared/utils/pageRoutes.constant';


const POC = () => {

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLDivElement;
            const imageUrl = target.getAttribute('data-background-image');
            if (imageUrl) {
              target.style.backgroundImage = `url(${imageUrl})`;
            }
            observer.unobserve(target);
          }
        });
      },
    );

    document.querySelectorAll('[data-background-image]').forEach((element) => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className='page-container-POC'>
      <div className='image-container' data-background-image={backgroundImage}>
        <LazyLoadImage
          alt="poc-background"
          effect="blur"
          wrapperClassName="background-image-placeholder"
        />
        <div className='text-container drop-in-2'>
          <h1 className='heading'>POC (Proof Of Concepts)</h1>
        </div>
        <p className='breadcrumb position-abs drop-in-3'>
          <Link className='breadcrumb-link' to={pageRoutes.Home} onClick={scrollToTop}>Home </Link>
          <span className="breadcrumb-separator"> / </span>
          <Link className='breadcrumb-link' to={pageRoutes.Services}>Services</Link>
          <span className="breadcrumb-separator"> / </span>
          <Link className='breadcrumb-link' to={pageRoutes.SoftwareEngineering} onClick={scrollToTop}>Software Engineering</Link>
          <span className="breadcrumb-separator"> / </span>
          <Link className='breadcrumb-link fw-light' to={pageRoutes.POC} onClick={scrollToTop}>Proof Of Concepts</Link>
        </p>
        <div className='red-bg-box'></div>
      </div>

      <CardsServices cardDataServices={POC_CONTENT} />
      <FooterServices />
      <Footer />
    </div>
  )
}

export default POC